import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ConstantsService } from '@app/base/core/services/constants.service';

export interface CanComponentDeactivate {
  canDeactivate: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState:
     RouterStateSnapshot) => Observable<boolean> | Promise<boolean> | boolean;
}

interface CanDeactivate<T> {
  canDeactivate(component: T, currentRoute: ActivatedRouteSnapshot, currentState:
     RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(     public constantsSVc: ConstantsService ) {}
  canDeactivate(component: CanComponentDeactivate, route: ActivatedRouteSnapshot, state:
     RouterStateSnapshot, nextState: RouterStateSnapshot) {
       if (component && component.canDeactivate) {
          window.history.pushState('', '', state.url);
       return component.canDeactivate(route, state, nextState);
       } else {
        return  true;
       }
  }
}

